import { useRef } from 'react'
import { useI18n } from '../../../provider/i18n'
import useBasketData from '../../../hooks/useBasketData'
import { Blue600, Red800 } from '../../../lib/colors'
import { MdDelete, MdKeyboardArrowRight } from 'react-icons/md'
import { Link } from 'react-router-dom'
import {
  ConfirmDialog,
  ConfirmDialogType,
} from '../../../components/ConfirmDialog'

const Tranings = () => {
  const i18n = useI18n()
  const confirmDialogRef = useRef<ConfirmDialogType>(null)
  const { trainings, orderCost, removeItem } = useBasketData()

  return (
    <div id="trainings-section" className="flex flex-col gap-2">
      <span className="text-lg md:text-xl font-bold">
        {i18n.t('screens.basket.sections.tranings.title')}
      </span>
      <ul className="flex flex-col gap-1">
        {trainings.map((item, i) => {
          const trainingCost = orderCost?.trainings?.find(
            ({ id }) => id === item.training.id
          )

          return (
            <li
              key={`training-${item.training.id}-${i}`}
              className="border-b border-b-border border-opacity-20 p-4 bg-white flex flex-col md:flex-row gap-5 items-center justify-center rounded-lg h-16"
            >
              <div className="flex gap-4 w-full justify-between">
                <div className="flex flex-col justify-center">
                  <p className="text-lg font-bold leading-tight">
                    <Link
                      to={`/training/${item.training.id}`}
                      style={{ textDecoration: 'none' }}
                    >
                      <span className="text-black">{item.training.name}</span>
                      <MdKeyboardArrowRight
                        size={20}
                        color={Blue600}
                        className="inline"
                      />
                    </Link>
                  </p>
                </div>
                <div className="flex flex-row items-start md:items-center gap-4">
                  <div>
                    {trainingCost && (
                      <div className="min-w-10">
                        <p className="text-base font-bold text-blue-700 whitespace-nowrap">
                          {i18n.t('screens.basket.form.orderTrainings.cost', {
                            cost: Number(trainingCost.cost).toFixed(2),
                          })}
                        </p>
                        {trainingCost.costBeforeDiscount && (
                          <p className="text-red-700 line-through text-right font-bold">
                            {i18n.t(
                              'screens.basket.form.orderTrainings.costBeforeDiscount',
                              {
                                cost: Number(
                                  trainingCost.costBeforeDiscount
                                ).toFixed(2),
                              }
                            )}
                          </p>
                        )}
                      </div>
                    )}
                    {!trainingCost && (
                      <p className="text-base font-bold text-blue-700 min-w-10 text-right whitespace-nowrap">
                        {i18n.t('screens.basket.form.orderTrainings.cost', {
                          cost: item.training.price,
                        })}
                      </p>
                    )}
                  </div>
                  <button
                    onClick={() => {
                      confirmDialogRef.current?.show({
                        message: i18n.t(
                          'screens.basket.form.orderTrainings.remove.alert.title',
                          {
                            trainingName: item.training.name,
                          }
                        ),
                        onSuccess: () => removeItem(item),
                      })
                    }}
                  >
                    <MdDelete size={24} color={Red800} />
                  </button>
                </div>
              </div>
            </li>
          )
        })}
      </ul>
      <ConfirmDialog ref={confirmDialogRef} />
    </div>
  )
}

export default Tranings
